import type { SessionStorageItems } from "./types";

export const SessionStorageItemTypes: Record<
  keyof SessionStorageItems,
  "string" | "number" | "boolean" | "object"
> = {
  "epg.ui": "object",
};
